export default "__VITE_ASSET__1af99584__"